import { ViewEnum } from '@/types';
import { choiceSettings } from './type';
import { marsChoiceSettings } from './mars-choice-settings';

export const  viewChoiceSettings: Record<ViewEnum, choiceSettings> = {
	[ViewEnum.galaxy]: {},
	[ViewEnum.mars]: marsChoiceSettings
}